/**
 * The Donate Form calls this class to set a cookie when a donation has been started
 * If the donation is completed, the cookie is deleted
 * 
 * If the donor does not complete the donation and returns to the charity/fundraising/campaign page, 
 * the cookie is used to trigger a message to the user, prompting them to complete their donation
 * 
 * THe notification on those pages is managed by AbandonedDonationNotification
 */

import AnalyticsEvent from 'Scripts/common/analytics-event';
import Cookie from 'Vendor/js-cookie';

export default class AbandonedDonationNotificationManager {
	constructor(opts) {
		this.type = opts.type;
		this.id = opts.id;
	}

	getCookieName() {
		return "gayl-abandoned-donation-" + this.type + "-" + this.id;
	}

	createCookie(amount) {
		console.log("AbandonedDonationNotificationManager.createCookie");

		// Only set cookie if there's a donation amount
		if(!amount) {
			return
		}

		Cookie.set(this.getCookieName(), amount, {
			expires: 1, // Days
		});
	}

	deleteCookie() {
		console.log("AbandonedDonationNotificationManager.deleteCookie");

		Cookie.remove(this.getCookieName());
	}
}